import { cva } from '@/styled-system/css';

export const comboboxClearRecipe = cva({
  base: {
    'display': 'inline-flex',
    'justifyContent': 'center',
    'alignItems': 'center',
    'flexShrink': 0,

    '& > button': {
      marginInline: 'calc(-1 * {spacing.Combobox.Clear.margin.horz})',
    },
  },
  variants: {
    size: {
      sm: {
        marginInlineStart: 'Combobox.Trigger.sm.gap.close-toSelect',
      },
      md: {
        marginInlineStart: 'Combobox.Trigger.md.gap.close-toSelect',
      },
      lg: {
        marginInlineStart: 'Combobox.Trigger.lg.gap.close-toSelect',
      },
    },
  },
});
